import { ArrowLeft } from "lucide-react";

const MOTS_VIDES = new Set(["de", "du", "des", "la", "le", "les", "d", "l", "et", "mme", "m", "mr"]);
export const initialesDe = (nom = "") => {
  const mots = nom.split(/[\s'’-]+/).filter((x) => x && !MOTS_VIDES.has(x.toLowerCase()));
  return mots.map((x) => x[0]).join("").slice(0, 2).toUpperCase();
};

export const Barre = ({ titre, sous, gauche, droite, onRetour, testId }) => (
  <div className="wa-barre" data-testid={testId}>
    {onRetour && <button type="button" onClick={onRetour} className="wa-retour at-icon-btn -ml-2" aria-label="Retour" data-testid={`${testId}-back`}><ArrowLeft size={20} /></button>}
    {gauche}
    <div className="min-w-0 flex-1"><h2>{titre}</h2>{sous && <p className="text-xs at-muted truncate">{sous}</p>}</div>
    {droite}
  </div>
);

export const Rond = ({ texte, couleur, taille, testId }) => (
  <span className="wa-rond" data-testid={testId} style={{ background: couleur || "var(--surface-3, var(--surface-2))", color: couleur ? "var(--sur-primaire, var(--accent-ink))" : "var(--ink)", ...(taille ? { width: taille, height: taille, fontSize: taille / 3 } : {}) }}>{texte}</span>
);

export const Ligne = ({ actif, onClick, rond, titre, sous, heure, badge, alerte, testId }) => (
  <button type="button" onClick={onClick} className={`wa-ligne ${actif ? "actif" : ""}`} data-testid={testId}>
    {rond}
    <span className="wa-ligne-corps">
      <span className="flex items-baseline justify-between gap-2"><span className="wa-ligne-titre truncate">{titre}</span>{heure && <span className="text-xs at-meta shrink-0">{heure}</span>}</span>
      <span className="flex items-center justify-between gap-2 mt-0.5"><span className="wa-ligne-sous truncate">{sous}</span>{badge ? <span className="wa-badge shrink-0" style={alerte ? { background: "var(--danger)", color: "var(--accent-ink)" } : undefined}>{badge}</span> : null}</span>
    </span>
  </button>
);

export const Bulle = ({ moi, ia, choisie, heure, children, testId }) => (
  <div className={`wa-bulle ${moi ? "moi" : ""} ${ia ? "ia" : ""} ${choisie ? "choisie" : ""}`} data-testid={testId}>
    <div className="text-[14.5px] leading-snug">{children}</div>
    {heure && <span className="wa-heure">{heure}</span>}
  </div>
);

export const Systeme = ({ children }) => <p className="wa-systeme">{children}</p>;

export const Puces = ({ items, valeur, onChange, testId }) => (
  <div className="wa-chips" data-testid={testId}>
    {items.map(([code, label]) => <button key={code} type="button" onClick={() => onChange(code)} className={`at-chip ${valeur === code ? "actif" : ""}`} data-testid={`${testId}-${code}`}>{label}</button>)}
  </div>
);

export const Colonnes = ({ ouvert, liste, fil, detail, testId }) => (
  <div className={`wa-cols ${ouvert ? "ouvert" : ""}`} data-testid={testId}>
    <section className="wa-liste">{liste}</section>
    <section className="wa-fil">{fil}</section>
    <aside className="wa-detail">{detail}</aside>
  </div>
);

export const Profil = ({ initiales, nom, sous, children, testId }) => (
  <div className="flex flex-col items-center text-center px-6 pt-8 pb-6" data-testid={testId}>
    <span className="wa-rond" style={{ width: 120, height: 120, fontSize: 40, background: "var(--menu-fond, var(--accent))", color: "var(--sur-primaire, var(--accent-ink))" }}>{initiales}</span>
    <p className="text-xl font-semibold mt-4">{nom}</p>
    {sous && <p className="text-sm at-muted mt-1">{sous}</p>}
    <div className="w-full mt-6 text-left">{children}</div>
  </div>
);

export const Info = ({ label, valeur, testId }) => (
  <div className="flex items-center justify-between gap-3 min-h-[44px] border-b at-sep text-sm" data-testid={testId}>
    <span className="at-muted">{label}</span><b className="tabular-nums text-right">{valeur}</b>
  </div>
);
